/** @format */

interface Options {
  totalCompanies: number;
  aliveCompanies: number;
  totalRestriction?: number | null;
  aliveRestriction?: number | null;
}

export const canCreateCompany = ({
  totalCompanies,
  aliveCompanies,
  totalRestriction,
  aliveRestriction,
}: Options): boolean => {
  if (typeof totalRestriction === 'number' && totalCompanies >= totalRestriction) {
    return false;
  }
  return !(typeof aliveRestriction === 'number' && aliveCompanies >= aliveRestriction);
};
